import React from 'react';

import { Box, Typography } from '@mui/material';

import { EmployerSimpleInfoFragment } from 'src/api';
import { LoadableEmployerLogo } from 'src/components/shared';
import { SxProp } from 'src/types/mui';

type PeoEmployersLiveStatusTableNameCellProps = {
  employer: EmployerSimpleInfoFragment;
};

export const PeoEmployersLiveStatusTableNameCell: React.FC<
  PeoEmployersLiveStatusTableNameCellProps
> = ({ employer }) => {
  return (
    <Box sx={containerStyles}>
      <Box sx={logoWithBadgeStyles}>
        <LoadableEmployerLogo employerId={employer.id} variant="circular" />
        <Typography sx={badgeStyles} hidden={!employer.setLiveAt}>
          <span>Live</span>
        </Typography>
      </Box>
      <Typography sx={nameStyles} variant="body2">
        {employer.displayName}
      </Typography>
    </Box>
  );
};

const containerStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

const logoWithBadgeStyles: SxProp = {
  position: 'relative',
};

const badgeStyles: SxProp = {
  position: 'absolute',
  bottom: -2,

  width: '100%',

  textAlign: 'center',
  fontSize: '.6em',

  '& > span': {
    backgroundColor: '#66bb6a',
    color: 'white',

    borderRadius: '30%',
    padding: '2px 4px',
  },
};

const nameStyles: SxProp = {
  fontWeight: 'bold',
};
